import 'css-chunksrc/client/scenes/wbs/task/allocationsList/details/group/completion/styles.scss';export default {
  "progressBar": "_progressBar_zj44q_1",
  "textProgressIndicator": "_textProgressIndicator_zj44q_10"
};